'use strict';

(function() {
  /**
   * Service pour la gestion des textes officiels
   * Communique avec l'API backend pour récupérer et manipuler les données
   */
  angular
    .module('observatoireApp')
    .service('TextesOfficielsService', ['$http', '$q', function($http, $q) {
  
  // API URL de base
  var baseApiUrl = '/api/textes-officiels';
  
  var mockTextesOfficiels = [
    {
      id: 1,
      title: 'Loi organique n°004/PR/2018 relative aux finances publiques',
      description: 'Cette loi organique définit le cadre juridique et institutionnel des finances publiques au Tchad, conformément aux directives de la CEMAC.',
      category: 'loi',
      date: '2018-09-15',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/loi-finances.jpg',
      fileUrl: 'assets/docs/loi-organique-finances-2018.pdf',
      fileSize: '2.5 MB',
      fileType: 'PDF',
      downloads: 205,
      views: 468,
      rating: 4.3,
      ratingCount: 56,
      userRating: 0,
      tags: ['finances', 'loi organique', 'CEMAC', '2018']
    },
    {
      id: 2,
      title: 'Décret n°762/PR/2020 portant code des marchés publics',
      description: 'Ce décret définit les règles et procédures relatives à la passation, l\'exécution et le contrôle des marchés publics au Tchad.',
      category: 'decret',
      date: '2020-05-20',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/marches-publics.jpg',
      fileUrl: 'assets/docs/decret-marches-publics-2020.pdf',
      fileSize: '3.1 MB',
      fileType: 'PDF',
      downloads: 318,
      views: 562,
      rating: 4.5,
      ratingCount: 73,
      userRating: 0,
      tags: ['marchés publics', 'décret', 'passation', '2020']
    },
    {
      id: 3,
      title: 'Loi n°027/PR/2019 portant statut général de la fonction publique',
      description: 'Cette loi définit le statut général des agents publics et les conditions de travail dans l\'administration publique tchadienne.',
      category: 'loi',
      date: '2019-11-10',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/fonction-publique.jpg',
      fileUrl: 'assets/docs/loi-fonction-publique-2019.pdf',
      fileSize: '2.8 MB',
      fileType: 'PDF',
      downloads: 276,
      views: 489,
      rating: 4.1,
      ratingCount: 62,
      userRating: 0,
      tags: ['fonction publique', 'statut', 'agents publics', '2019']
    },
    {
      id: 4,
      title: 'Arrêté n°153/MFB/2022 fixant le calendrier de préparation budgétaire',
      description: 'Cet arrêté établit le calendrier et les modalités de préparation du budget général de l\'État pour l\'exercice 2023.',
      category: 'arrete',
      date: '2022-06-05',
      author: 'Ministère des Finances et du Budget',
      thumbnail: 'assets/images/textes-officiels/calendrier-budget.jpg',
      fileUrl: 'assets/docs/arrete-calendrier-budget-2022.pdf',
      fileSize: '1.5 MB',
      fileType: 'PDF',
      downloads: 184,
      views: 325,
      rating: 3.9,
      ratingCount: 45,
      userRating: 0,
      tags: ['budget', 'calendrier', 'préparation', '2022']
    },
    {
      id: 5,
      title: 'Loi n°001/PR/2015 portant code pétrolier',
      description: 'Cette loi définit le cadre juridique des activités de prospection, d\'exploration et d\'exploitation des hydrocarbures au Tchad.',
      category: 'loi',
      date: '2015-02-18',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/code-petrolier.jpg',
      fileUrl: 'assets/docs/loi-code-petrolier-2015.pdf',
      fileSize: '4.2 MB',
      fileType: 'PDF',
      downloads: 412,
      views: 678,
      rating: 4.6,
      ratingCount: 89,
      userRating: 0,
      tags: ['pétrole', 'hydrocarbures', 'code', '2015']
    },
    {
      id: 6,
      title: 'Décret n°345/PR/2021 relatif à la transparence des industries extractives',
      description: 'Ce décret met en œuvre les normes de l\'ITIE (Initiative pour la Transparence dans les Industries Extractives) au Tchad.',
      category: 'decret',
      date: '2021-03-30',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/transparence-extractives.jpg',
      fileUrl: 'assets/docs/decret-transparence-extractives-2021.pdf',
      fileSize: '2.3 MB',
      fileType: 'PDF',
      downloads: 245,
      views: 418,
      rating: 4.4,
      ratingCount: 52,
      userRating: 0,
      tags: ['ITIE', 'transparence', 'extractives', '2021']
    },
    {
      id: 7,
      title: 'Loi n°018/PR/2016 portant code des douanes',
      description: 'Cette loi définit l\'ensemble des règles applicables aux opérations d\'importation et d\'exportation de marchandises au Tchad.',
      category: 'loi',
      date: '2016-07-25',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/code-douanes.jpg',
      fileUrl: 'assets/docs/loi-code-douanes-2016.pdf',
      fileSize: '3.7 MB',
      fileType: 'PDF',
      downloads: 298,
      views: 512,
      rating: 4.0,
      ratingCount: 67,
      userRating: 0,
      tags: ['douanes', 'importation', 'exportation', '2016']
    },
    {
      id: 8,
      title: 'Instruction n°078/MFB/2022 relative à l\'exécution du budget',
      description: 'Cette instruction précise les modalités pratiques d\'exécution du budget général de l\'État pour l\'exercice 2022.',
      category: 'instruction',
      date: '2022-01-15',
      author: 'Ministère des Finances et du Budget',
      thumbnail: 'assets/images/textes-officiels/execution-budget.jpg',
      fileUrl: 'assets/docs/instruction-execution-budget-2022.pdf',
      fileSize: '1.8 MB',
      fileType: 'PDF',
      downloads: 156,
      views: 287,
      rating: 3.8,
      ratingCount: 41,
      userRating: 0,
      tags: ['budget', 'exécution', 'finances', '2022']
    },
    {
      id: 9,
      title: 'Décret n°512/PR/2019 portant code des investissements',
      description: 'Ce décret définit le cadre juridique, institutionnel et les conditions des investissements privés au Tchad.',
      category: 'decret',
      date: '2019-05-08',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/code-investissements.jpg',
      fileUrl: 'assets/docs/decret-code-investissements-2019.pdf',
      fileSize: '2.9 MB',
      fileType: 'PDF',
      downloads: 264,
      views: 458,
      rating: 4.2,
      ratingCount: 58,
      userRating: 0,
      tags: ['investissements', 'code', 'privé', '2019']
    },
    {
      id: 10,
      title: 'Circulaire n°029/PM/2021 relative à la rationalisation des dépenses publiques',
      description: 'Cette circulaire établit des mesures de rationalisation des dépenses publiques dans le cadre de la maîtrise du déficit budgétaire.',
      category: 'circulaire',
      date: '2021-09-22',
      author: 'Primature du Tchad',
      thumbnail: 'assets/images/textes-officiels/rationalisation-depenses.jpg',
      fileUrl: 'assets/docs/circulaire-rationalisation-depenses-2021.pdf',
      fileSize: '1.3 MB',
      fileType: 'PDF',
      downloads: 197,
      views: 345,
      rating: 3.7,
      ratingCount: 39,
      userRating: 0,
      tags: ['dépenses', 'rationalisation', 'déficit', '2021']
    },
    {
      id: 11,
      title: 'Loi n°032/PR/2017 portant code général des impôts',
      description: 'Cette loi définit l\'ensemble des dispositions fiscales applicables aux personnes physiques et morales au Tchad.',
      category: 'loi',
      date: '2017-11-30',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/code-impots.jpg',
      fileUrl: 'assets/docs/loi-code-impots-2017.pdf',
      fileSize: '5.1 MB',
      fileType: 'PDF',
      downloads: 387,
      views: 642,
      rating: 4.3,
      ratingCount: 76,
      userRating: 0,
      tags: ['impôts', 'fiscalité', 'code', '2017']
    },
    {
      id: 12,
      title: 'Décret n°098/PR/2020 fixant la nomenclature budgétaire de l\'État',
      description: 'Ce décret établit la nomenclature budgétaire de l\'État conformément aux normes de la CEMAC et aux pratiques internationales.',
      category: 'decret',
      date: '2020-02-12',
      author: 'Présidence de la République du Tchad',
      thumbnail: 'assets/images/textes-officiels/nomenclature-budget.jpg',
      fileUrl: 'assets/docs/decret-nomenclature-budget-2020.pdf',
      fileSize: '2.2 MB',
      fileType: 'PDF',
      downloads: 219,
      views: 378,
      rating: 4.1,
      ratingCount: 48,
      userRating: 0,
      tags: ['nomenclature', 'budget', 'CEMAC', '2020']
    }
  ];

  var mockCategories = [
    { id: 'loi', name: 'Lois' },
    { id: 'decret', name: 'Décrets' },
    { id: 'arrete', name: 'Arrêtés' },
    { id: 'instruction', name: 'Instructions' },
    { id: 'circulaire', name: 'Circulaires' }
  ];
  
  /**
   * Formate correctement les dates des textes officiels
   * @param {Array} textes - Liste de textes officiels
   * @returns {Array} Liste de textes officiels avec dates formatées
   */
  function formatDates(textes) {
    if (!textes || !textes.length) return textes;
    
    return textes.map(function(texte) {
      var texteFormate = angular.copy(texte);
      
      // Corriger le format de date si c'est un tableau ou une chaîne
      if (texte.date) {
        // Si c'est un tableau [année, mois, jour, heure, minute...]
        if (Array.isArray(texte.date)) {
          var dateArray = texte.date;
          if (dateArray.length >= 3) {
            // Créer un objet date JavaScript (attention: les mois sont basés sur 0 en JS)
            texteFormate.date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2],
                                        dateArray.length > 3 ? dateArray[3] : 0,
                                        dateArray.length > 4 ? dateArray[4] : 0);
          }
        } 
        // Si c'est une chaîne ISO (2022-06-05T00:00:00)
        else if (typeof texte.date === 'string' && texte.date.includes('T')) {
          texteFormate.date = new Date(texte.date);
        }
      }
      
      return texteFormate;
    });
  }
  
  /**
   * Récupère tous les textes officiels directement depuis l'API backend
   * @returns {Promise} Une promesse avec les textes officiels
   */
  this.getAllTextesOfficiels = function() {
    console.log('API URL utilisée:', baseApiUrl);
    var deferred = $q.defer();
    
    // Forcer l'appel à l'API en désactivant le cache
    $http({
      method: 'GET',
      url: baseApiUrl,
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'If-Modified-Since': '0'
      },
      cache: false
    })
      .then(function(response) {
        console.log('Données reçues de l\'API:', response);
        // L'API renvoie un objet avec les propriétés content, totalItems, etc.
        if (response && response.data && response.data.content) {
          console.log('Nombre d\'items reçus de l\'API:', response.data.content.length);
          
          // Formater les dates avant de retourner les données
          var textes = formatDates(response.data.content);
          deferred.resolve(textes);
        } else {
          console.error('Format de réponse API inattendu:', response);
          deferred.resolve([]);
        }
      })
      .catch(function(error) {
        console.warn('API indisponible, utilisation des données mockées:', error);
        deferred.resolve(formatDates(mockTextesOfficiels));
      });
    
    return deferred.promise;
  };
  
  /**
   * Récupère un texte officiel par son ID
   * @param {number} id - L'ID du texte officiel
   * @returns {Promise} Une promesse avec le texte officiel
   */
  this.getTexteOfficielById = function(id) {
    var deferred = $q.defer();
    
    $http.get(baseApiUrl + '/' + id)
      .then(function(response) {
        deferred.resolve(response.data);
      })
      .catch(function(error) {
        console.error('Erreur lors de la récupération du texte officiel', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
  
  /**
   * Incrémente le nombre de vues pour un texte officiel
   * @param {number} id - L'ID du texte officiel
   * @returns {Promise} Une promesse avec le texte officiel mis à jour
   */
  this.incrementViews = function(id) {
    var deferred = $q.defer();
    
    $http.post(baseApiUrl + '/' + id + '/increment-views')
      .then(function(response) {
        deferred.resolve(response.data);
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'incrémentation des vues', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
  
  /**
   * Incrémente le nombre de téléchargements pour un texte officiel
   * @param {number} id - L'ID du texte officiel
   * @returns {Promise} Une promesse avec le texte officiel mis à jour
   */
  this.incrementDownloads = function(id) {
    var deferred = $q.defer();
    
    $http.post(baseApiUrl + '/' + id + '/increment-downloads')
      .then(function(response) {
        deferred.resolve(response.data);
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'incrémentation des téléchargements', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
  
  /**
   * Soumet une note pour un texte officiel
   * @param {number} id - L'ID du texte officiel
   * @param {number} rating - La note (1-5)
   * @returns {Promise} Une promesse avec le texte officiel mis à jour
   */
  this.rateTexteOfficiel = function(id, rating) {
    var deferred = $q.defer();
    
    // S'assurer que la note est entre 1 et 5
    rating = Math.min(Math.max(parseInt(rating) || 0, 1), 5);
    
    // Envoyer la note au serveur
    $http.post(baseApiUrl + '/' + id + '/rate', null, {
      params: { rating: rating }
    })
      .then(function(response) {
        // Mettre à jour la note utilisateur côté client pour l'affichage
        var texteOfficiel = response.data;
        texteOfficiel.userRating = rating;
        
        // Formater la date si elle est présente sous forme de tableau ou de chaîne
        if (texteOfficiel.date) {
          // Si c'est un tableau [année, mois, jour, heure, minute...]
          if (Array.isArray(texteOfficiel.date)) {
            var dateArray = texteOfficiel.date;
            if (dateArray.length >= 3) {
              // Créer un objet date JavaScript (attention: les mois sont basés sur 0 en JS)
              texteOfficiel.date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2],
                                    dateArray.length > 3 ? dateArray[3] : 0,
                                    dateArray.length > 4 ? dateArray[4] : 0);
            }
          } 
          // Si c'est une chaîne ISO (2022-06-05T00:00:00)
          else if (typeof texteOfficiel.date === 'string' && texteOfficiel.date.includes('T')) {
            texteOfficiel.date = new Date(texteOfficiel.date);
          }
        }
        
        // Enregistrer la note dans localStorage pour persistance locale
        try {
          var savedRatings = JSON.parse(localStorage.getItem('texteOfficielRatings') || '{}');
          savedRatings[texteOfficiel.id] = rating;
          localStorage.setItem('texteOfficielRatings', JSON.stringify(savedRatings));
        } catch (e) {
          console.error('Erreur lors de l\'enregistrement de la note locale', e);
        }
        
        deferred.resolve(texteOfficiel);
      })
      .catch(function(error) {
        console.error('Erreur lors de la notation du texte officiel', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
  
  /**
   * Charge les notes utilisateur précédemment attribuées depuis localStorage
   * @returns {Object} Un objet avec les ID de textes officiels comme clés et les notes comme valeurs
   */
  this.loadUserRatings = function() {
    try {
      return JSON.parse(localStorage.getItem('texteOfficielRatings') || '{}');
    } catch (e) {
      console.error('Erreur lors du chargement des notes utilisateur', e);
      return {};
    }
  };
  
  /**
   * Récupère les textes officiels par catégorie directement depuis l'API backend
   * @param {string} category - La catégorie à filtrer
   * @returns {Promise} Une promesse avec les textes officiels filtrés
   */
  this.getTexteOfficielsByCategory = function(category) {
    console.log('Récupération des textes officiels par catégorie:', category);
    console.log('URL API appelée:', baseApiUrl + '/category/' + category);
    
    var deferred = $q.defer();
    
    // Forcer l'appel à l'API en désactivant le cache
    $http({
      method: 'GET',
      url: baseApiUrl + '/category/' + category,
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'If-Modified-Since': '0'
      },
      cache: false
    })
      .then(function(response) {
        console.log('Données reçues de l\'API pour la catégorie', category, ':', response);
        
        // L'API renvoie un objet avec les propriétés content, totalItems, etc.
        if (response && response.data && response.data.content) {
          console.log('Nombre d\'items reçus pour la catégorie', category, ':', response.data.content.length);
          
          // Formater les dates avant de retourner les données
          var textes = formatDates(response.data.content);
          deferred.resolve(textes);
        } else {
          console.warn('Format de réponse API inattendu pour la catégorie', category, ':', response);
          deferred.resolve([]);
        }
      })
      .catch(function(error) {
        console.error('Erreur lors du chargement des textes officiels par catégorie', category, ':', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
  
  /**
   * Récupère les catégories de textes officiels
   * @returns {Promise} Une promesse avec les catégories
   */
  this.getCategories = function() {
    var deferred = $q.defer();
    
    $http.get(baseApiUrl + '/categories')
      .then(function(response) {
        deferred.resolve(response.data);
      })
      .catch(function(error) {
        console.warn('API catégories indisponible, utilisation des données mockées:', error);
        deferred.resolve(mockCategories);
      });
    
    return deferred.promise;
  };
  
  /**
   * Recherche des textes officiels
   * @param {string} query - Le terme de recherche
   * @returns {Promise} Une promesse avec les résultats de recherche
   */
  this.searchTextesOfficiels = function(query) {
    var deferred = $q.defer();
    
    // Si la recherche est vide, retourner tous les textes officiels
    if (!query || query.trim() === '') {
      return this.getAllTextesOfficiels();
    }
    
    // Effectuer la recherche via l'API
    $http.get(baseApiUrl + '/search', {
      params: { keyword: query }
    })
      .then(function(response) {
        deferred.resolve(response.data.content);
      })
      .catch(function(error) {
        console.error('Erreur lors de la recherche de textes officiels', error);
        deferred.reject(error);
      });
    
    return deferred.promise;
  };
    }]);
})();
